import { useMemo } from 'react';
/**
 *
 */
export const useProductImage = (props) => {
    const { product, unit } = props;
    const firstImage = useMemo(() => (product?.product_images || [])
        .slice()
        .sort((a, b) => a.image_position - b.image_position)[0], [product?.product_images]);
    const currentImage = useMemo(() => {
        return unit && product?.product_images?.length
            ? product?.product_images.find((image) => String(image.image_id) === String(unit?.image_id))
            : null;
    }, [product?.product_images, unit]) || firstImage;
    return {
        currentImage,
        productImageSrc: firstImage?.image_src ?? '',
        currentImageSrc: currentImage?.image_src,
        altText: currentImage?.image_alt_text ?? product?.product_name ?? '',
    };
};
